/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QualificationEnum {
	Excellent = "Excellent",
	VeryGood = "VeryGood",
	Good = "Good",
	Satisfactory = "Satisfactory",
	Unsatisfactory = "Unsatisfactory",
}

export function QualificationEnumFromJSON(json: any): QualificationEnum {
	return QualificationEnumFromJSONTyped(json, false);
}

export function QualificationEnumFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): QualificationEnum {
	return json as QualificationEnum;
}

export function QualificationEnumToJSON(value?: QualificationEnum | null): any {
	return value as any;
}
